import React, { Component } from 'react';
import '../styles.css';
import { DISABLED, SELECTED, DOT_SIZE } from '../const.js';
import { HIDDEN } from '../../HOME/const';

class Dot extends Component {
  render() {
    var { x, y, clickSize, visibility, size } = this.props;

    if (visibility === HIDDEN) {
      return null;
    }

    const margin = `${y - clickSize / 2}px 0 0 ${x - clickSize / 2}px`;
    const dotSize = `${size || DOT_SIZE}px`;
    const width = `${clickSize}px`;
    const height = width;

    var color = 'radial-gradient(circle at 40% 30%, white 1px, lime 3%, darkgreen 65%, lime 100%)';

    switch (visibility) {
      case DISABLED:
        color = 'rgba(0,0,0,0.35)';
        break;
      case SELECTED:
        color = 'radial-gradient(circle at 40% 30%, white 1px, orange 3%, orangered 65%, orange 100%)';
        break;
      case HIDDEN:
        color = 'transparent';
        break;
      default:
        break;
    }

    const styles = {
      click: {
        width,
        height,
        margin: margin,
        gridArea: '1/1',
        display: 'grid',
        alignItems: 'center',
        justifyItems: 'center',
        zIndex: 1,
      },
      dot: {
        gridArea: '1/1',
        width: dotSize,
        height: dotSize,
        borderRadius: '50%',
        background: color,
        marginBottom: '-1px',
      },
    };

    return (
      <div style={styles.click} onTouchStart={this.props.onTouch} onMouseDown={this.props.onMouseDown}>
        {visibility === DISABLED ? null : (
          <div style={{ ...styles.dot, background: 'black', margin: '0 -1px -2px 0' }} />
        )}
        <div style={styles.dot} />
      </div>
    );
  }
}

export default Dot;
